import React, { Component } from 'react';
import { CookiesProvider } from 'react-cookie';
import axios from 'axios';
import Header from '../../../Components/V2/Header';
import Footer from '../../../Components/V2/Footer';
import path from 'path';
import videojs from 'video.js';

export default class VideoNews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailed: {},
      hots: [],
    };
    this.player = null;
  }

  componentDidMount() {
    //call api
    this.getArticle();
  }

  componentDidUpdate() {
    if (this.player === null) {
    }
  }

  getArticle = () => {
    axios
      .get(`/api/v1/video/article/${path.basename(window.location.pathname)}`)
      .then(({ data }) => {
        if (data.success) {
          this.setState({
            detailed: data.payload.article,
            hots: data.payload.related,
          });
        }
      });
  };

  render() {
    const { detailed, hots } = this.state;
    return (
      <CookiesProvider>
        <div className='category-page'>
          <Header />
          <main className='main_content sidebar_right pb-50'>
            <div class='container'>
              <div class='single-header-3 single-header-2 row no-gutters mb-50 background12 border-radius-5'>
                <div class='col-lg-12 col-md-12 order-1 order-lg-2'>
                  {detailed.video && (
                    <video
                      id='my-player'
                      controls
                      preload='auto'
                      className='video-js vjs-theme-fantasy'
                      data-setup='{}'
                      poster={detailed.video_poster}
                      style={{ height: '500px', width: '100%' }}
                    >
                      <source src={detailed.video} type='video/mp4'></source>
                      <p class='vjs-no-js'>
                        To view this video please enable JavaScript, and
                        consider upgrading to a web browser that
                        <a
                          href='https://videojs.com/html5-video-support/'
                          target='_blank'
                        >
                          supports HTML5 video
                        </a>
                      </p>
                    </video>
                  )}
                </div>
              </div>
            </div>
            <div class='container'>
              <div class='row'>
                <div class='col-lg-8 col-md-12 col-sm-12'>
                  <div class='single-excerpt'>
                    <div class='entry-header entry-header-1'>
                      <div class='entry-meta meta-0 font-small mb-30'>
                        <a href='category.html'>
                          <span
                            class='post-cat background2 color-white'
                            style={{
                              backgroundColor:
                                detailed.background_color_category,
                            }}
                          >
                            {detailed.name_category}
                          </span>
                        </a>
                      </div>
                      <h1 class='post-title'>
                        <a href='single.html'>{detailed.title}</a>
                      </h1>
                      <div class='entry-meta meta-1 font-small color-grey mt-15 mb-15'>
                        <span class='post-on has-dot'>
                          {detailed.scheduled}
                        </span>
                      </div>
                      <div class='bt-1 border-color-1 mt-30 mb-30'></div>
                    </div>
                  </div>
                  <div class='single-excerpt'>
                    <p class='font-large'>
                      <b>
                        <i>{detailed.short_description}</i>
                      </b>
                    </p>
                  </div>
                  <div class='entry-main-content'>
                    {detailed.content && (
                      <>
                        <hr class='wp-block-separator is-style-wide' />
                        <article>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: detailed.content,
                            }}
                          />
                        </article>
                      </>
                    )}
                  </div>
                </div>
                <div class='col-lg-4 col-md-12 col-sm-12 primary-sidebar sticky-sidebar'>
                  <div class='widget-area pl-30'>
                    <div class='sidebar-widget widget-social-network mb-50'>
                      <div class='widget-header position-relative mb-20 pb-10'>
                        <h5 class='widget-title mb-10'>Theo dõi SMEdx</h5>
                        <div class='bt-1 border-color-1'></div>
                      </div>
                      <div class='social-network'>
                        <div class='follow-us d-flex align-items-center'>
                          <a
                            class='follow-us-facebook clearfix mr-5 mb-10'
                            href='https://www.facebook.com/SMEdx.vn'
                            target='_blank'
                          >
                            <div class='social-icon'>
                              <i class='ti-facebook mr-5 v-align-space'></i>
                              <i class='ti-facebook mr-5 v-align-space nth-2'></i>
                            </div>
                            <span class='social-name'>Facebook</span>
                          </a>
                          <a
                            class='follow-us-youtube clearfix ml-5 mb-10'
                            href='https://www.youtube.com/watch?v=kWoaWKeSrXw&t=4s&ab_channel=MIMEDIA'
                            target='_blank'
                          >
                            <div class='social-icon'>
                              <i class='ti-youtube mr-5 v-align-space'></i>
                              <i class='ti-youtube mr-5 v-align-space nth-2'></i>
                            </div>
                            <span class='social-name'>Youtube</span>
                          </a>
                        </div>
                      </div>
                    </div>
                    {hots.length > 0 && (
                      <div class='sidebar-widget widget_alitheme_lastpost mb-50'>
                        <div class='widget-header position-relative mb-20 pb-10'>
                          <h5 class='widget-title mb-10'>Video khác</h5>
                          <div class='bt-1 border-color-1'></div>
                        </div>
                        <div class='post-block-list'>
                          {hots.map((item) => (
                            <a
                              href={`/${
                                item.is_video_news === 1
                                  ? 'tin-video'
                                  : 'tin-tuc'
                              }/${item.slug}`}
                            >
                              <article class='mb-30'>
                                <div class='post-thumb position-relative thumb-overlay mb-30'>
                                  <div
                                    class='img-hover-slide border-radius-5 position-relative'
                                    style={{
                                      backgroundImage: `url(${item.thumbnail})`,
                                    }}
                                  >
                                    <a
                                      class='img-link'
                                      href={`/${
                                        item.is_video_news === 1
                                          ? 'tin-video'
                                          : 'tin-tuc'
                                      }/${item.slug}`}
                                    ></a>
                                    {/* <span class='top-right-icon background8'>
                                  <i class='mdi mdi-camera-alt'></i>
                                </span> */}
                                  </div>
                                </div>
                                <div class='post-content'>
                                  <div class='entry-meta meta-0 font-small mb-15'>
                                    <a href={`/tin-tuc/${item.slug_category}`}>
                                      <span
                                        class='post-cat background9 color-white'
                                        style={{
                                          backgroundColor:
                                            item.background_color_category,
                                        }}
                                      >
                                        {item.name_category}
                                      </span>
                                    </a>
                                  </div>
                                  <h4 class='post-title'>
                                    <a
                                      href={`/${
                                        item.is_video_news === 1
                                          ? 'tin-video'
                                          : 'tin-tuc'
                                      }/${item.slug}`}
                                    >
                                      {item.title}
                                    </a>
                                  </h4>
                                  <div class='entry-meta meta-1 font-small color-grey mt-15 mb-15'>
                                    <span class='post-on'>
                                      {item.scheduled}
                                    </span>
                                    {/* <span class='time-reading has-dot'>
                                  12 mins read
                                </span>
                                <span class='hit-count'>
                                  <i class='ti-bolt'></i> 19k Views
                                </span> */}
                                  </div>
                                </div>
                              </article>
                            </a>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
          <Footer />
        </div>
      </CookiesProvider>
    );
  }
}
